import { getTPAMSReportsFlags } from '@telstra-connect/tpams-reports/feature-flags/load-flags';
import { isFlagOn } from '@telstra-connect/tpams-reports/feature-flags';
import { ApplicationName } from '@telstra-connect/tpams-reports/activity-tracking';
import { secureRouteBuilder } from '../secure-route';
import Routes from './route-constants';
import {
    IApplicationDefinition,
    IAppRegistry,
} from '@apps-config/app-definition';
import { Activity } from '@utils/activity-tracking';
import { TPAMSKbReports } from './pages/tpams-reports/index-lazy';
import { TPAMSMonthlyReports } from './pages/tpams-monthly-reports/index-lazy';
import { RoutesHelper } from '@apps-config/routing/routing';
import { NewCard } from './components/new-card/index-lazy';

const routes = new RoutesHelper({
    rootPath: secureRouteBuilder(Routes.TPAMSReports),
    subpagesPathMask: secureRouteBuilder(Routes.TPAMSReports),
});
const applicationName = ApplicationName;
const tracker = Activity.createTracker(applicationName);

export const Application: IApplicationDefinition = {
    get applicationName() {
        return 'TPAMS reports';
    },

    get acceptsUserFeedback() {
        return true;
    },

    get acceptsErrorReports() {
        return true;
    },

    get card() {
        return NewCard;
    },

    get tracker() {
        return tracker;
    },

    get routes() {
        return routes;
    },

    init(registry: IAppRegistry, availableToUser: boolean) {
        const flags = getTPAMSReportsFlags();
        if (isFlagOn(flags.application)) {
            if (availableToUser) {
                registry.add(Application);
            }
        }
    },

    render() {
        return [
            {
                path: routes.getPageSubpath(Routes.TPAMSKbReportsRoute),
                component: TPAMSKbReports,
            },
            {
                path: routes.getAppPath(),
                component: TPAMSMonthlyReports,
            },
        ];
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    menuItem(state, navigate) {
        return [
            {
                testID: 'ui-menu-tpams-reports',
                name: 'Reporting and performance',
                intialPagePath: routes.getInitialPagePath(),
                appPath: routes.getAppPath(),
                notificationsCount: 0,
                onClick: () => {
                    Application.tracker.trackMenu(applicationName);
                    return navigate(routes.getInitialPagePath());
                },
            },
        ];
    },
};

export { Routes };
